import { getFirst } from 'junctions-fp'

//////////////////////////////////////////
// EXPORT GETTERS
/////////////////////////////////////////
export default {
  getCurrentFormat: state => state.currentFormat,
  getFormatList: state => state.formatList,
  templatesList: state => state.templates,
  currentTemplate: state => state.templates.find(template => template.id === state.currentTemplate),
  getColorList: state => state.limitations.colors || [],
  getFontsList: state => state.limitations.fonts || [],
  getLimitations: state => state.limitations,
  getFontFormat: state => state.fontFormat,
  getCurrentColor: state => state.currentColor,
  getLanguages: async state => {
    const i = await import(`../lang/${state.currentLang.toUpperCase()}`)
    return i.default
  },
  canSaveLocal: state => state.canSaveLocal,
  openedMode: state => state.openedMode,
  getDomain: state => state.domain,
  getRestrictedSize: state => state.restrictedSize,
  getUpgradeEvent: state => state.upgradeEvent,
  getEditorMaxSize: state => state.editor,
  closeButton: state => state.closeButton,
  saveMenuList: state => state.saveMenuList
}



// WEBPACK FOOTER //
// ./src/model/store/getters.js